import React from 'react'

import FeatureTourCarousel from 'pages/shared/FeatureTourModal/FeatureTourCarousel'

import Modal from 'components/Modal'
import { SiteMessageDetail } from 'types/SiteMessageDetail'

type Props = {
  open: boolean
  title: string
  message: string
  siteMessages: Array<SiteMessageDetail>
  closeCallback: (string)=> void
}

const FeatureTourModal = ({ open, title, message, siteMessages, closeCallback }: Props) => {
  return (
    <Modal variant="md" isDisplayed={open} closeCallback={() => closeCallback('Close')}>
      { open &&
        <FeatureTourCarousel
          title={title}
          message={message}
          siteMessages={siteMessages}
          closeCallback={closeCallback}
        />
        }
    </Modal>
  )
}

export default FeatureTourModal
